import React, { type ComponentType } from 'react';
import type { NavigationItem } from '@atlassian/jira-navigation-types/src/types.tsx';

type Props = {
	itemType: string | undefined;
	SelectItemTypeModal: ComponentType<{
		onClose: () => void;
		onAddLink: () => void;
		onAddRepo: () => void;
	}>;
	AddLinkModal: ComponentType<{
		baseUrl: string;
		projectKey: string;
		onAddItemCompleted: (arg1: { item: NavigationItem | undefined }) => void;
	}>;
	AddRepositoryModal: ComponentType<{
		baseUrl: string;
		projectKey: string;
		onAddItemCompleted: (arg1: { item: NavigationItem | undefined }) => void;
	}>;
	baseUrl: string;
	projectKey: string;
	onAddItemCompleted: (arg1: { item: NavigationItem | undefined }) => void;
	onAddLink: () => void;
	onAddRepo: () => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => {
	const {
		itemType,
		baseUrl,
		projectKey,
		onAddItemCompleted,
		AddRepositoryModal,
		AddLinkModal,
		SelectItemTypeModal,
		onAddLink,
		onAddRepo,
	} = props;
	const onClose = () => {
		onAddItemCompleted({ item: undefined });
	};

	if (itemType === 'repository') {
		return (
			<AddRepositoryModal
				baseUrl={baseUrl}
				projectKey={projectKey}
				onAddItemCompleted={onAddItemCompleted}
			/>
		);
	}
	if (itemType === 'link') {
		return (
			<AddLinkModal
				baseUrl={baseUrl}
				projectKey={projectKey}
				onAddItemCompleted={onAddItemCompleted}
			/>
		);
	}
	return <SelectItemTypeModal onClose={onClose} onAddLink={onAddLink} onAddRepo={onAddRepo} />;
};
